import { stack } from "@styled-system/patterns";

export const wrapperClass = stack({
	gap: "32",
});

export const buttonsWrapperClass = stack({
	gap: "16",
});
